<template>
  <div class="w-full pt-16 bg-black text-white" :key="currentLessonActive">
    <!-- Grid principal -->
    <div class="container mx-auto px-4 grid grid-cols-1 lg:grid-cols-12 gap-6 mt-3">
      <!-- Coluna esquerda - Player -->
      <div class="lg:col-span-8">
        <!-- Player -->
        <LivePlayer />

        <!-- Informações do vídeo -->
        <div class="mt-2 text-start p-4 pt-0">
          <div class="flex justify-between">
            <div>
              <h1 class="text-3xl tracking-wider font-semibold mb-1">
                {{ 
                  currentLessonActive?.title ?? 
                  currentModule?.modules[0].title ?? 
                  'X Solution Tecnologia e Gestão em Segurança do Trabalho' 
                }}
              </h1>
            </div>
          </div>

          <!-- 
            TODO: verificar método 
            os pontos estão sendo subtraídos apenas quando erro as questões e não quando acerto
          -->
          <!-- <LessonScoreBar
            v-if="currentLessonActive?.id"
            :lesson-id="currentLessonActive.id"
            :questions="currentLessonActive?.questions || []"
          /> -->

          <hr>

          <!-- Descrição -->
          <p class="text-xl leading-relaxed text-gray-300">
            {{ currentModule?.description }}
          </p>
        </div>
      </div>

      <!-- Aulas do modulo -->
      <div class="lg:col-span-4 space-y-1">
        <h3 class="text-2xl font-berthold-force tracking-wider text-start font-extrabold text-white mb-4 uppercase border-b border-gray-400">
          {{ currentModule?.title }}
        </h3>

        <!-- modulos -->
        <Timeline 
          :modules="currentModule?.modules"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  PhThumbsDown,
  PhThumbsUp
} from '@phosphor-icons/vue'
import { onBeforeMount, watch, computed, ref } from 'vue'
import LivePlayer from '@/shared/components/live/LivePlayer.vue'
import SharedService from '@/shared/services/shared'
import { dataShared } from '@/shared/store'
import { useRoute } from 'vue-router'
import router from '@/router'
import Timeline from '../auth/components/modules/Timeline.vue'
import { dataProgress } from '@/shared/store/progress'
import { formatDate } from '@/utils/formaters'
import { showToast as toast } from '@/helpers/UseToasts'
import LessonScoreBar from '@/shared/components/__partials/LessonScoreBar.vue'

const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const banner = require('@/assets/logo/icon.png')

const route = useRoute()
const currentModule = computed(() => dataShared.getters.getActivatedModule)
const currentLessonActive = computed(() => dataShared.getters.getActivatedLesson)
const trainingId = computed(() => route.params.mId || currentModule.value?.id || null)

watch(trainingId, async (n) => {
  if (n) {
    await dataProgress.dispatch('fetchTrainingProgress', n)
  }
})

async function getModuleData (eId) {
  await SharedService.activeModulePlaying(eId)
    .then(res => {
      console.log(res.data);
      dataShared.dispatch('setModuleActivated', res.data)
    }).catch(err => {
      console.log(err);
    })
}

onBeforeMount(async () => {
  dataShared.dispatch('activeLoading')
  window.scrollTo(0, 0)

  await dataShared.dispatch('fetchLoggedUser')

  if (!route.params.mId || trainingId.value == null) {
    return router.push('/collect')
  }

  if (trainingId.value) {
    await dataProgress.dispatch('fetchTrainingProgress', trainingId.value)
  }

  Promise.all([
    getModuleData(route.params.mId)
    // watchEvent(),
  ])

  dataShared.dispatch('desactiveLoading')
})
</script>

<style lang="scss" scoped>
p {
  margin: 10px 0;
}
</style>
